export default "/images/54ba2e7c6da4daebdf8ffada0254666c.png";